(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-service', {
            parent: 'entity',
            url: '/type-service?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeService.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-service/type-services.html',
                    controller: 'TypeServiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-service-detail', {
            parent: 'entity',
            url: '/type-service/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeService.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-service/type-service-detail.html',
                    controller: 'TypeServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeService');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeService', function($stateParams, TypeService) {
                    return TypeService.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-service.new', {
            parent: 'type-service',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-service/type-service-dialog.html',
                    controller: 'TypeServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-service', null, { reload: true });
                }, function() {
                    $state.go('type-service');
                });
            }]
        })
        .state('type-service.edit', {
            parent: 'type-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-service/type-service-dialog.html',
                    controller: 'TypeServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeService', function(TypeService) {
                            return TypeService.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-service', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-service.delete', {
            parent: 'type-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-service/type-service-delete-dialog.html',
                    controller: 'TypeServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeService', function(TypeService) {
                            return TypeService.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-service', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
